export const moveType = {
    walk: 1,
    drive: 2,
    swim: 3,
    fly: 4
};
